import React, { Component } from 'react';
import { DFPSlotsProvider, AdSlot } from 'react-dfp';
import TrackVisibility from 'react-on-screen';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import classNames from 'classnames';

import { StaticContents } from 'components/ServerSideComponents.jsx';
import styles from '../scss/partials/hero.scss';
import Header from './header';

import {
  cube,
  megaphone,
  share
} from './images';
/*
 * This is the InternalPageHero component that has a header
 * at the top of the page and controls to open a sidebar
 */
export default class Hero extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loaded: false,
			width: document.body.clientWidth
		};
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	@autobind
	handleResize() {
		this.setState({
			width: document.body.clientWidth
		});
	}

	@autobind
	onLoad() {
		this.setState({
			loaded: true
		});
	}

  // note: not being used
  // just trying other ad library to get
  // something to show (outside of bulbs-dfp)
	renderAdSlot() {
		const adUnits = [
			{ viewport: [1024, 768], sizes: [[728, 90], [300, 250]] },
			{ viewport: [900, 768], sizes: [[300, 250]] }
		];

		return (
			<div className={styles.bannerAd}>
				<DFPSlotsProvider
					dfpNetworkId='4246'
					targetingArguments={{
						adSite: 'fmg.theroot100',
						dfp_pagetype: 'homepage',
						dfp_section: 'theroot100interactive',
						dfp_site: 'fmg.theroot100'
					}}
					sizeMapping={adUnits}
				>
					<div className={styles.desktop}>
						<AdSlot sizes={[[728,90], [300, 250]]} adUnit='homepage/1' />
					</div>
					<div className={styles.mobile}>
						<AdSlot sizes={[[320,50], [300, 50]]} adUnit='homepage/mobile' />
					</div>
				</DFPSlotsProvider>
			</div>
		);
	}

	renderSectorList() {
		const { filter, sectors, updateFilter } = this.props;

		let indicatorClass;
		let linkClass;

		return sectors && sectors.map((sector, i) => {
			indicatorClass = classNames(styles.sectorIndicator, styles[sector]);
			linkClass = classNames({ [styles.inactive]: filter && filter !== sector }, styles.sectorGroup);

			return (
				<a key={i} className={linkClass} onClick={(e) => updateFilter(sector, e)}>
					<div className={indicatorClass} />
					<div className={styles.sector}>{sector}</div>
				</a>
			);
		});
	}

	render() {
		return (
			<div className={styles.heroWrap}>
				<TrackVisibility partialVisibility throttleInterval={800}>
					<Header resetAndScrollIntoView={this.props.resetAndScrollIntoView} filter={this.props.filter} onLoad={this.onLoad} />
				</TrackVisibility>
				<div className={styles.mainInner}>
					<div className={styles.mainIntro}>
						<p><b>The Root 100</b> is our annual list of the most influential African Americans, ages 25 to 45.
						It’s our way of honoring the innovators, the leaders, the public figures and game changers
						whose work from the past year is breaking down barriers and paving the way for the next generation.
						This year’s list of honorees is a reminder of the beauty and brilliance of blackness, at a time when
						the political and cultural landscape has grown even more hostile to the idea of black achievement.
						</p>
						<div className={styles.info}>
						How did we arrive at the list? By using a unique algorithm, we calculate honorees’ <StaticContents>
							<div className={styles.stat}>{share} REACH</div></StaticContents> — the people they touch through media
							along with Twitter and Instagram followers — and their <StaticContents>
							<div className={styles.stat}>{cube} SUBSTANCE</div></StaticContents> — the
							impact of their work, graded on a scale of 0 to 10 — to determine their <StaticContents>
							<div className={styles.stat}>{megaphone} INFLUENCE</div></StaticContents>, which
							determines their ranking. Ultimately, we scored hundreds of people to determine <b>The Root 100</b>.
							Congratulations to this year’s honorees!
						</div>
						<div className={styles.sectorFilters}>
							<p>Explore the list in order or by sector:</p>
							<div className={styles.sectorList}>
								{this.renderSectorList()}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Hero.propTypes = {
	filter: PropTypes.string,
	sectors: PropTypes.array.isRequired,
	updateFilter: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./theroot/root-100-2019/src/components/hero.js